import {ChangeDetectionStrategy, Component, computed, inject} from '@angular/core';
import {CareproviderUnitService} from '../../../../../../services/careprovider-unit.service';
import {HsaObject} from '../../../../../../types/HsaObject';
import {DataLayerParamsClickGA4} from '../../../../../../types/DataLayerParamsClickGA4';
import {DLPageTypeEnum} from '../../../../../../enums/DataLayerEnums';
import {CareproviderHelper} from '../../../../../../services/careprovider.helper';
import {RoutesEnums} from '../../../../../../enums/RoutesEnums';

@Component({
  selector: 'app-cpru-about',
  templateUrl: './cpru-about.component.html',
  styleUrl: './cpru-about.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block md:rounded-lg md:border md:border-grey-9 md:bg-white md:px-4 md:py-5',
  },
})
export class CpruAboutComponent {
  private careproviderUnitService = inject(CareproviderUnitService);
  protected careproviderUnit = this.careproviderUnitService.careproviderUnit;
  public dataLayerParamsClickGA4 = computed<DataLayerParamsClickGA4>(() => {
    return {
      callToAction: null,
      pageType: this.careproviderUnit()?.isCustomer
        ? DLPageTypeEnum.CARE_PROVIDER_PAGE
        : DLPageTypeEnum.HSA_CARE_PROVIDER_PAGE,
    };
  });
  public landingPageRoute = computed<Array<string>>(() =>
    this.careproviderUnit().caregiver?.isLandingPageActive
      ? ['/', RoutesEnums.CAREPROVIDER, this.careproviderUnit().caregiver?.urlPath]
      : undefined,
  );
  private careproviderHelper = inject(CareproviderHelper);
  public updateDateFormatted = computed<string>(() =>
    this.careproviderHelper.formatDate(this.careproviderUnit()?.updatedAt),
  );
  public temporaryInformationContent = computed<string[]>(() => {
    const hsaObjects: HsaObject[] = this.careproviderHelper.getTemporaryInformation(
      this.careproviderUnit()?.hsaObjects,
    );
    const content: string[] = hsaObjects.map((o) => o.hsaTemporaryInformation.temporaryInformation);
    return [...new Set(content)];
  });
}
